export const environment = {
  production: true,
  api_url: 'https://api.bemum.co',
  crisp_website_id: '732eedcf-885d-4263-aff4-7c99d939fbaf',
};
